import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '@/graphql/config/cache/util/invalidateQuery';

const tuitionOfferDecisionExchange: UpdatesConfig['Mutation'] = {
  tuitionOfferDecisionCreate: (_: Data, __: Variables, cache: Cache) => invalidateQuery(
    ['tuitionOfferDecisions', 'tuitionOffer'],
    cache,
  ),
};

export default tuitionOfferDecisionExchange;
